import Button from 'components/shared/Button';
import Image from 'components/shared/Image';
import Layout from 'src/components/shared/Layout';
import NextImage from 'src/components/shared/NextImage';
import Img from 'components/shared/Image/Img'
import RichText from 'src/components/typo/RichText/RichText';
import css from './styles.module.scss';

const SectionWithImage = ({
    label,
    line,
    shape,
    title,
    text,
    textPosition,
    quote,
    button,
    author,
    image
}) => {
    const sectionPositioning = textPosition === 'right' ? css.rightAligned : css.leftAligned;
    const TopSectionComponent = () => {
        if(shape){
            return (
              <div className={css.shape}>
                <NextImage
                  {...shape}
                />
              </div>
            )
        }if(label){
            return (
              <div className={css.label}>
                {label}
              </div>
            )
        }if(line){
            return (
              <div className={css.line} />
            )
        }
            
return null
        
    }
    
return (
  <Layout type="maxWidth">
    <div className={[css.section,sectionPositioning].join(' ')}>
      <div className={css.content}>
        {TopSectionComponent && (
        <div className={css.topSection}>
          <TopSectionComponent />
        </div>
                        )}
        <h2 className={css.subtitle}>{title}</h2>
        <RichText className={css.text} text={text} />
        {quote && (
        <div>
          <p className={css.quote}>“ {quote} ”</p>
          <div className={css.author}>
            <div>
              <Img
                {...author.image}
                className={css.img}
              />
            </div>
            <div>
              <span className={css.name}>{author.name}</span>
              <span className={css.description}>{author.description}</span>
            </div>
          </div>
        </div>
                    )}
                    
        {button && (
        <div className={css.button}>
          <Button {...button} />
        </div>
                    )}
      </div>
      <div className={css.image}>
        <Image fit="cover" {...image} />
      </div>
    </div>
  </Layout>
    )
}

export default SectionWithImage;